import TotalAmountRequested from "components/Rover/Widgets/TotalAmountRequested";
import TotalApplicationsWidget from "components/Rover/Widgets/TotalApplicationsWidget";
import TotalProgramFundsWidget from "components/Rover/Widgets/TotalProgramFundsWidget";
import Card from "components/UI/Card";

/* Services */

/* Assets */
import { EApplicationStatus } from "features/ApplicationForm/constants";
import { convertEnumToText, isObjectEmpty } from "utils";

export function CHDOAllApplications({
  data: widgetsData,
}: {
  data: Record<string, any>;
}) {
  return (
    <div className="my-4">
      <section className="my-4 grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        <TotalApplicationsWidget count={widgetsData?.totalApplications ?? 0} />
        <TotalAmountRequested count={widgetsData?.totalAmountRequested ?? 0} />
        <TotalProgramFundsWidget count={widgetsData?.totalProgramFunds ?? 0} />
      </section>
      <Card title="Status Summary">
        <>
          <div className="grid grid-cols-8 gap-6 py-6 px-6">
            {!isObjectEmpty(EApplicationStatus) &&
              Object.keys(EApplicationStatus).map((s: any) => (
                <div className="col-span-2 font-medium flex justify-between gap-6">
                  <span>
                    {convertEnumToText(
                      EApplicationStatus[s as keyof typeof EApplicationStatus]
                    )}
                  </span>
                  <span>{widgetsData["statusSummary"][s] ?? 0}</span>
                </div>
              ))}
          </div>
        </>
      </Card>
    </div>
  );
}
